import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";

import { PublicProtectionProfile } from "api/public/protectionProfiles/protectionProfiles.types";

import { getStatusInfo } from "../../utils/statusControl";

interface PpListItemProps {
  listItem: PublicProtectionProfile;
}

export default function PpListItem({ listItem }: PpListItemProps) {
  const { statusColor, statusLabel } = getStatusInfo(listItem.sunset_date);

  return (
    <Card elevation={3} sx={{ backgroundColor: "#f8f9fa" }}>
      <Box display="flex">
        <Box
          sx={{
            width: "8px",
            backgroundColor: statusColor,
            flexShrink: 0,
          }}
        />
        <CardContent sx={{ flex: 1, py: 2 }}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            {listItem.pp_name}
          </Typography>

          <Box display="flex" gap={4} mb={2}>
            <Stack>
              <Typography variant="body2" sx={{ textDecoration: "underline" }}>
                Short Name
              </Typography>
              <Link to={`/protectionprofiles/${listItem.pp_id}`}>
                <Typography fontWeight="bold" color="primary">
                  {listItem.pp_short_name}
                </Typography>
              </Link>
            </Stack>
            <Stack>
              <Typography variant="body2" sx={{ textDecoration: "underline" }}>
                Technology Type
              </Typography>
              <Typography fontWeight="bold">{listItem.tech_type}</Typography>
            </Stack>
          </Box>

          <Box display="flex" gap={4} mb={2}>
            {listItem?.pp_date && (
              <Stack>
                <Typography
                  variant="body2"
                  sx={{ textDecoration: "underline" }}
                >
                  Approval Date
                </Typography>
                <Typography fontWeight="bold">
                  {moment.utc(listItem.pp_date).format("MM/DD/YYYY")}
                </Typography>
              </Stack>
            )}
            <Stack>
              <Typography variant="body2" sx={{ textDecoration: "underline" }}>
                CC Version
              </Typography>
              <Typography fontWeight="bold">{listItem.cc_version}</Typography>
            </Stack>
          </Box>

          <Box display="flex" gap={4}>
            {listItem?.sunset_date && (
              <Stack>
                <Typography
                  variant="body2"
                  sx={{ textDecoration: "underline" }}
                >
                  Sunset Date
                </Typography>
                <Typography fontWeight="bold">
                  {moment.utc(listItem.sunset_date).format("MM/DD/YYYY")}
                </Typography>
              </Stack>
            )}
            <Stack>
              <Typography variant="body2" sx={{ textDecoration: "underline" }}>
                Sponsor
              </Typography>
              <Typography fontWeight="bold">
                {listItem.pp_sponsor_id}
              </Typography>
            </Stack>
          </Box>
        </CardContent>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          justifyContent="space-between"
          p={2}
        >
          <Typography
            variant="body2"
            display="flex"
            alignItems="center"
            gap={0.5}
          >
            <FontAwesomeIcon icon={faCircle} color={statusColor} size="xs" />
            {statusLabel}
          </Typography>

          <Button
            component={Link}
            to={`/protectionprofiles/${listItem.pp_id}`}
            variant="outlined"
            sx={{
              color: "text.primary",
              borderColor: "text.primary",
              "&:hover": {
                backgroundColor: "text.primary",
                borderColor: "text.primary",
                color: "background.paper",
              },
            }}
          >
            Full Details
          </Button>
        </Box>
      </Box>
    </Card>
  );
}
